// Optional sign-in shortcut. Never used as proof of tenant access.
const KEY = 'remembered_organisation'
const PENDING_KEY = 'remember_organisation_oidc'
const LIFETIME = 30 * 24 * 60 * 60 * 1000
const OIDC_LIFETIME = 10 * 60 * 1000

export function forgetOrganisation() {
  try { localStorage.removeItem(KEY) } catch { /* Storage may be unavailable. */ }
}

export function getRememberedOrganisation() {
  try {
    // The old value was written without an explicit preference. Do not migrate it.
    localStorage.removeItem('last_tenant')
    const saved = JSON.parse(localStorage.getItem(KEY))
    if (saved && typeof saved.slug === 'string' && saved.slug &&
        typeof saved.name === 'string' && Number.isFinite(saved.expiresAt) && saved.expiresAt > Date.now()) return saved
  } catch { /* Missing, corrupt or unavailable storage means no shortcut. */ }
  forgetOrganisation()
  return null
}

export function saveOrganisation(tenant, remember) {
  if (!remember) {
    forgetOrganisation()
    return
  }
  if (!tenant?.slug) return
  try {
    localStorage.setItem(KEY, JSON.stringify({
      slug: tenant.slug, name: tenant.name || tenant.slug, expiresAt: Date.now() + LIFETIME,
    }))
  } catch { /* Sign-in still works without optional storage. */ }
}

// Carry this sign-in's choice across the IdP redirect, scoped to its OIDC state.
export function stageOrganisationChoice(authorizationUrl, remember) {
  try {
    sessionStorage.removeItem(PENDING_KEY)
    const state = new URL(authorizationUrl, window.location.origin).searchParams.get('state')
    if (state && typeof remember === 'boolean') sessionStorage.setItem(PENDING_KEY, JSON.stringify({ state, remember, expiresAt: Date.now() + OIDC_LIFETIME }))
  } catch { /* Sign-in still works without optional storage. */ }
}

export function consumeOrganisationChoice(state) {
  try {
    const pending = JSON.parse(sessionStorage.getItem(PENDING_KEY))
    sessionStorage.removeItem(PENDING_KEY)
    if (pending?.state === state && pending.expiresAt > Date.now() && typeof pending.remember === 'boolean') return pending.remember
  } catch { /* No matching choice. */ }
  return null
}
